module.exports = __webpack_public_path__ + "media/nl_nl_s4_Lotte.dfa62962.oga";